import React from 'react';
import { Container, Paper, Typography, Button, Box } from '@mui/material';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function PaymentResult() {
  const { t } = useTranslation();
  const { status } = useParams();

  const isSuccess = status === 'success';

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Paper
        sx={{
          p: 4,
          textAlign: 'center',
          bgcolor: isSuccess ? '#e8f5e9' : '#ffebee',
        }}
      >
        <Typography
          variant="h4"
          color={isSuccess ? 'success.main' : 'error.main'}
          gutterBottom
        >
          {isSuccess ? t('paymentResult.successTitle') : t('paymentResult.failTitle')}
        </Typography>

        <Typography variant="body1" sx={{ mb: 3 }}>
          {isSuccess
            ? t('paymentResult.successText')
            : t('paymentResult.failText')}
        </Typography>

        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
          <Button variant="contained" component={Link} to="/">
            {t('paymentResult.home')}
          </Button>
          {!isSuccess && (
            <Button variant="outlined" onClick={() => window.history.back()}>
              {t('paymentResult.retry')}
            </Button>
          )}
        </Box>
      </Paper>
    </Container>
  );
}
